<template>
<section class="container">
  <section class="main_top">
    <h3>{{plateNo}}</h3>
    <p>派发日期: {{bindTime}}</p>
    <p>派发总券数: {{bindCount}}张</p>
  </section>
  <section class="list" v-if="parkCouponDetailBeanList.length > 0">
    <section class="list_item" v-for="(item,index) in parkCouponDetailBeanList" :key="index">
      <section class="item_left">
        <p class="time_title">使用时间:</p>
        <p class="time_value">{{item.useTime|formatTime(11)}}</p>
        <p class="use_num">使用: {{item.usedCount}}张</p>
      </section>
      <section class="item_right">
        <p class="should_pay">应付: ¥{{item.temporaryAmount|priceFormat}}</p>
        <p class="discont">抵扣: -¥{{item.diffAmount|priceFormat}}</p>
        <p class="pay_money">实付: ¥{{item.payAmount|priceFormat}}</p>
      </section>
    </section>
  </section>
</section>
</template>
<script>
import {mapState} from 'vuex'
import { callSpaceUp } from '../../utils/api'
import util from '../../utils/util'
export default {
  name: 'dispatchRecordDetail',
  props: {},
  components: {
  },
  filters: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      parkCouponDetailBeanList:[],
      bindCount:0,
      bindTime:'',
      plateNo:''
    }
  },
  created(){
    this.bindTime = this.$route.query.bindTime;
    this.plateNo = this.$route.query.plateNo;
    this.queryMyParkCouponDetail()
  },
  methods:{
    queryMyParkCouponDetail(){
      util.showLoading()
      let params = {
        couponHeaderId: this.$route.query.couponHeaderId,
        phone: this.common.userInfo.phone || this.common.userInfo.account,
        plateNo:this.$route.query.plateNo,
        bindTime:this.$route.query.bindTime,
        url: "/parking/rstParkCoupon/queryMyParkCouponDetail"
      }
      callSpaceUp(params).then(res=>{
        util.hideLoading()
        console.log(res)
        if(res.res.code === 10000){
          this.bindCount = res.body.data.bindCount;
          this.parkCouponDetailBeanList = res.body.data.parkCouponDetailBeanList || [];
        }else{
          util.showToast(res.res.msg)
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  background:#eee;
}
.main_top{
  padding:40px 0 20px 40px;
  background:#fff;
  h3{
    font-size:48px;
    color:rgba(51,51,51,1);
    line-height:66px;
    margin-bottom: 20px;
  }
  p{
    font-size:28px;
    color:rgba(102,102,102,1);
    line-height:40px;
    margin-bottom: 20px;
  }
}
.list_item{
  margin:20px;
  background:rgba(255,255,255,1);
  box-shadow:0px 4px 8px 0px rgba(201,201,201,0.02);
  border-radius:8px;
  .flex();
  justify-content: space-between;
  padding:28px;
  box-sizing: border-box;
  .item_left{
    .time_title{
      font-size:26px;
      color:rgba(153,153,153,1);
      line-height:36px;
      margin-bottom:4px;
    }
    .time_value{
      font-size:28px;
      color:rgba(51,51,51,1);
      line-height:40px;
      margin-bottom:30px;
    }
    .use_num{
      font-size:26px;
      color:rgba(23,64,218,1);
      line-height:36px;
    }
  }
  .item_right{
    text-align: right;
    .should_pay{
      font-size:26px;
      color:rgba(51,51,51,1);
      line-height:36px;
    }
    .discont{
      font-size:26px;
      color:rgba(255,126,30,1);
      line-height:36px;
      margin:14px 0;
    }
    .pay_money{
      font-size:32px;
      color:rgba(51,51,51,1);
      line-height:44px;
    }
  }
}
</style>
